var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGutschein(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "surface3168",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.964,
    height: 48.951,
    viewBox: "0 0 46.964 48.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M22.568.984a1.976,1.976,0,0,0-1.636.871A1.931,1.931,0,0,0,20.757,3.7l1.75,4.4L17.707,5.2a1.987,1.987,0,0,0-1.116-.29,1.964,1.964,0,0,0-.9,3.654l3.73,2.232H6.914A3.911,3.911,0,0,0,3,14.713v3.914H24.525V14.713h1.391a1.863,1.863,0,0,0,.543.076h.015a2.167,2.167,0,0,0,.581-.076h1.384v3.914H49.964V14.713A3.911,3.911,0,0,0,46.05,10.8H33.545l3.73-2.232a1.96,1.96,0,0,0-.955-3.654,2,2,0,0,0-1.062.29l-4.8,2.889,1.75-4.4a1.958,1.958,0,0,0-.191-1.865A1.982,1.982,0,0,0,30.334.992a1.948,1.948,0,0,0-1.75,1.254L26.482,7.5l-2.1-5.251A1.952,1.952,0,0,0,22.568.984ZM4.957,22.54V46.022A3.911,3.911,0,0,0,8.87,49.935H24.525V22.54Zm23.482,0v27.4H44.093a3.911,3.911,0,0,0,3.914-3.914V22.54Zm0,0",
    transform: "translate(-3 -0.984)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGutschein);
export default __webpack_public_path__ + "static/media/gutschein.d62a7024f3f51d27c1ebad1d8458e7ac.svg";
export { ForwardRef as ReactComponent };